import { OverlayUtil, strokeShapeIndicators } from "@tldraw/editor";
class CollaboratorShapeIndicatorOverlayUtil extends OverlayUtil {
  static type = "collaborator_shape_indicator";
  options = { zIndex: 49, lineWidth: 1.5, alpha: 0.7 };
  isActive() {
    return this.editor.getVisibleCollaboratorsOnCurrentPage().some((presence) => presence.selectedShapeIds.length > 0);
  }
  getOverlays() {
    const editor = this.editor;
    const selectedPresences = editor.getVisibleCollaboratorsOnCurrentPage().filter((presence) => presence.selectedShapeIds.length > 0);
    if (selectedPresences.length === 0) return [];
    const renderingShapeIds = new Set(editor.getRenderingShapes().map((s) => s.id));
    const indicators = [];
    for (const presence of selectedPresences) {
      const visibleShapeIds = presence.selectedShapeIds.filter(
        (id) => renderingShapeIds.has(id) && !editor.isShapeHidden(id)
      );
      if (visibleShapeIds.length === 0) continue;
      indicators.push({ color: presence.color, shapeIds: visibleShapeIds });
    }
    if (indicators.length === 0) return [];
    return [
      {
        id: "collaborator_shape_indicator",
        type: "collaborator_shape_indicator",
        props: { indicators }
      }
    ];
  }
  render(ctx, overlays) {
    const overlay = overlays[0];
    if (!overlay) return;
    const editor = this.editor;
    const zoom = editor.getZoomLevel();
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.lineWidth = this.options.lineWidth / zoom;
    ctx.globalAlpha = this.options.alpha;
    for (const { color, shapeIds } of overlay.props.indicators) {
      ctx.strokeStyle = color;
      strokeShapeIndicators(editor, ctx, shapeIds);
    }
    ctx.globalAlpha = 1;
  }
}
export {
  CollaboratorShapeIndicatorOverlayUtil
};
//# sourceMappingURL=CollaboratorShapeIndicatorOverlayUtil.mjs.map
